import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import ReminderForm, {
  ReminderFormFields,
} from '../../components/Reminder/ReminderForm';

export default function RemindersNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: ReminderFormFields) => {
    try {
      await api.post(`organizations/${organization.id}/reminders`, data);

      navigate('/reminders');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<ReminderFormFields>(
    {} as ReminderFormFields
  );

  return (
    <ReminderForm
      isLoading={1 + 1 === 1}
      title='Novo Lembrete'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
